import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';

import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';

import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import DeleteIcon from '@mui/icons-material/Delete';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import Service from "../services/Service";
import Alert from '@mui/material/Alert';
import InputLabel from '@mui/material/InputLabel';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { Box, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ListItemButton, ListItemIcon, Stack } from '@mui/material';


function AddKeyField(props) {
  const { addItem, handleDelete } = props;
  const [val, setVal] = useState("");
  const inputRef = useRef(null);

  const handleClick = () => {
    if (addItem) {
      addItem(val);
      setVal("");

      inputRef.current.firstChild.focus();
      inputRef.current.firstChild.placeholder = '';

    }
  }
  const handleOnChange = (e) => {
    setVal(e.target.value);
  }

  return (
    <Paper
      component="form"
      sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }}
    >
      {/* <IconButton sx={{ p: '10px' }} aria-label="menu">
        <MenuIcon />
      </IconButton> */}
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        // placeholder="AaaA"
        inputProps={{ 'aria-label': 'search google maps' }}
        value={val}
        autoFocus
        ref={inputRef}
        onChange={handleOnChange}
      />

      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
      <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions"
        onClick={handleClick}
      >
        <AddCircleOutlinedIcon />
      </IconButton>
    </Paper>
  );
}

function DialogCuston(props) {
  const { open, onClose, dinamico, onChange } = props;
  const [itens, setItens] = useState();

  useEffect(() => {
    setItens(dinamico);
  }, [dinamico]);

  const deleteItem = (acao, item) => {
    setItens(prevItens => {
      const novoArray = prevItens[acao].filter(i => i !== item);
      return {
        ...prevItens,
        [acao]: novoArray
      };
    });
  }

  const handleClick = (e, val) => {
    setItens(prevItens => {
      const novoArray = prevItens[e];
      novoArray.push(val)
      return {
        ...prevItens,
        [e]: novoArray
      };
    });
  }

  const onChangeSalver = () => {
    onChange(itens, dinamico);
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>Campo dinamico</DialogTitle>
      <DialogContent>
        <Stack
          direction="row"
          spacing={1}
          sx={{
            flexWrap: 'wrap',
            gap: 1,
            mb: 1,
            pt: 1,
            marginInlineStart: 1
          }}
        >
          {itens?.inclusao?.map((inc, i) => (
            <Chip
              key={`inc_dialog-${i}`}
              label={inc}
              color="success"
              variant="outlined"
              onDelete={() => deleteItem("inclusao", inc)}
              deleteIcon={<DeleteIcon />}
            />
          ))}
          {itens?.exclusao?.map((inc, i) => (
            <Chip
              key={`exec_dialog-${i}`}
              label={inc}
              color="error"
              variant="outlined"
              onDelete={() => deleteItem("exclusao", inc)}
              deleteIcon={<DeleteIcon />}
            />
          ))}
        </Stack>
        <TextFieldDinamico onClick={handleClick} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Sair</Button>
        <Button onClick={onChangeSalver}>Salvar</Button>
      </DialogActions>
    </Dialog>
  )
}

function TextFieldDinamico(props) {
  const { onClick } = props;
  const [value, setValue] = useState("");
  const onChange = (e) => {
    setValue(e.target.value);
  }

  const onClickIcon = (campo) => {
    onClick(campo, value);
    setValue("");
  }
  return (
    <Paper
      component="form"
      sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        // placeholder="Nova Chave"
        value={value}
        onChange={onChange}
      />
      <IconButton color='error' sx={{ p: '10px' }} onClick={() => onClickIcon("exclusao")} >
        <ClearIcon />
      </IconButton>
      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
      <IconButton color='success' sx={{ p: '10px' }} onClick={() => onClickIcon("inclusao")} >
        < DoneIcon />
      </IconButton>
    </Paper>
  );
}

export default function ConfigForm(props) {
  const { setWait } = props;
  const [key, setKey] = useState([]);
  const [emails, setEmails] = useState([]);
  const [keyImportante, setKeyImportante] = useState([]);
  const [dynamicKey, setDynamicKey] = useState([]);
  const [config, setConfig] = useState();
  const [urlRef, setUrlRef] = useState("");
  const [erro, setErro] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [dinamico, setDinamico] = useState();

  useEffect(() => {
    Service.GET("/api/config/list", setWait).then(response => {
      console.log("-->", response);
      if (response && response.length > 0) {
        setConfig(response[0]);
        setKeyImportante(response[0].keyImportante)
        setKey(response[0].key);
        setDynamicKey(response[0].dynamicKey || [])
        if (response[0].emails)
          setEmails(response[0].emails);
        setUrlRef(response[0].urlRef);
      }

    }).catch(error => {
      if (error.message === 'duplicado') return;
      console.error(error);
      setErro(error.statusText);
    });
  }, []);

  const handleDelete = (id) => {
    const val = key[id];
    let arr = [...key];
    arr = arr.filter(item => item !== val);
    setKey(arr);
  }
  const handleDeleteImportante = (id) => {
    const val = keyImportante[id];
    let arr = [...keyImportante];
    arr = arr.filter(item => item !== val);
    setKeyImportante(arr);
  }
  const handleDeleteEmail = (id) => {
    const val = emails[id];
    let arr = [...emails];
    arr = arr.filter(item => item !== val);
    setEmails(arr);
  }
  const addItem = (item) => {
    let dado = [...key];
    dado.push(item);
    setKey(dado);
  }

  const addItemImportante = (item) => {
    if (!keyImportante) {
      setKeyImportante([item]);
    } else {
      let dado = [...keyImportante];
      dado.push(item);
      setKeyImportante(dado);
    }
  }
  const addItemDinamico = (campo, value) => {
    let array = [...dynamicKey];
    array.push({
      ...{ inclusao: [], exclusao: [] },
      [campo]: [value]
    });
    setDynamicKey(array);
  }
  const handleClickDeleteDinamico = (item) => {
    setDynamicKey(e => e.filter(i => i !== item));
  }

  const addItemEmail = (item) => {
    let dado = [...emails];
    dado.push(item);
    setEmails(dado);
  }
  const handleSave = () => {
    let dado = { ...config };
    dado.urlRef = urlRef;
    dado.key = key;
    dado.keyImportante = keyImportante;
    dado.emails = emails;
    dado.dynamicKey = dynamicKey;

    Service.POST('/api/config', dado).then(resp => {
      // setWait(false);
      // sair();
      console.log(">>>salve<<<", resp)
      setConfig(resp)
    }).catch(error => {
      console.error(error);
      // setWait(false);
      // setMensagem(error? error: 'Oops! Something went wrong. Please try again!');
    })
  }

  const handleClickOpenDialog = (chave) => {
    setDinamico(chave);
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const onChangeDialog = (novo, antigo) => {
    setDynamicKey(e => {
      return e.map(item => {
        if (item === antigo) {
          return novo;
        }
        return item;
      });
    });
    setOpenDialog(false);
  };

  return (
    <Container maxWidth="xl" sx={{ p: 4 }}>
      <Grid container spacing={2}>
        {erro &&
          <Grid item xs={12}>
            <Alert severity="error">{erro}</Alert>
          </Grid>
        }
        <Grid item xs={10}>
          <TextField
            required
            id="outlined-required"
            label="URL de referencia"
            fullWidth sx={{ m: 1 }}
            defaultValue="https://www.licinet.com.br/xml/GerarEmailDoCliente.php?edicao=Licinet+Tarde+13/04/2022&cliente=62745&chave=e&telemarketing=0&nome=Very Tecnologia Ltda Epp&email=comercial@verytecnologia.com.br"
          />
        </Grid>
        <Grid item xs={2}>
          <Button variant="contained" endIcon={<SaveAltIcon />} onClick={handleSave}>
            Salvar
          </Button>
        </Grid>

        <Grid item xs={3}>
          <InputLabel  >
            Chave de Busca
          </InputLabel>
          <AddKeyField addItem={addItem} handleDelete={handleDelete} label={"Chave busca licinetes"} />
        </Grid>
        <Grid item xs={3}>
          <InputLabel  >
            Chave de Busca Importante
          </InputLabel>
          <AddKeyField addItem={addItemImportante} label={"Chave busca licinetes"} />
        </Grid>
        <Grid item xs={3}>
          <InputLabel  >
            Chave de Busca dinamica
          </InputLabel>
          <TextFieldDinamico onClick={addItemDinamico} />
          {/* <AddKeyField addItem={addItemDinamico} label={"Chave busca licinetes"} /> */}
        </Grid>
        <Grid item xs={3}>
          <InputLabel  >
            Email
          </InputLabel>
          <AddKeyField addItem={addItemEmail} handleDelete={handleDeleteEmail} label={"email"} />
        </Grid>

        <Grid item xs={3}>
          <Paper sx={{ maxWidth: 400 }}>
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} >
              {key.map((val, index) => (
                <ListItem key={index}
                  secondaryAction={
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDelete(index)}>
                      <DeleteIcon />
                    </IconButton>
                  }
                >
                  <ListItemText
                    primary={val}
                  // secondary={'Secondary text'}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
        <Grid item xs={3}>
          <Paper sx={{ maxWidth: 400 }}>
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} >
              {keyImportante.map((val, index) => (
                <ListItem key={index}
                  secondaryAction={
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteImportante(index)}>
                      <DeleteIcon />
                    </IconButton>
                  }
                >
                  <ListItemText
                    primary={val}
                  // secondary={'Secondary text'}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
        <Grid item xs={3}>
          <Paper sx={{ maxWidth: 400 }}>
            {dynamicKey?.map((val, index) => (
              <div key={`grup-${index}`} sx={{ mb: 3 }} >
                <Stack
                  direction="row"
                  spacing={0}
                  sx={{
                    flexWrap: 'wrap',
                    gap: 1,
                    mb: 1,
                    pt: 1,
                    marginInlineStart: 1
                  }}
                >
                  {val?.inclusao?.map((inc, i) => (
                    <Chip
                      key={`inc-${index}-${i}`}
                      label={inc}
                      color="success"
                      variant="outlined"
                      icon={<DoneIcon />}
                      sx={{ maxWidth: '168px' }}
                    />
                  ))}
                  {val?.exclusao?.map((inc, i) => (
                    <Chip
                      key={`exc-${index}-${i}`}
                      label={inc}
                      color="error"
                      variant="outlined"
                      icon={<ClearIcon />}
                    />
                  ))}
                  {/* <Chip
                    variant="outlined"
                    label="Editar"
                    icon={<EditIcon />}
                    onClick={() => handleClickOpenDialog(val)}
                  />
                  <Chip
                    variant="outlined"
                    label="Excluir"
                    icon={<DeleteIcon />}
                    onClick={() => handleClickDeleteDinamico(val)}
                  /> */}
                </Stack>
                <Stack
                  direction="row"
                  spacing={1}
                  sx={{
                    flexWrap: 'wrap',
                    gap: 1,
                    marginInlineStart: 1
                  }}
                >
                  <Chip
                    variant="outlined"
                    label="Editar"
                    icon={<EditIcon />}
                    onClick={() => handleClickOpenDialog(val)}
                  />
                  <Chip
                    variant="outlined"
                    label="Excluir"
                    icon={<DeleteIcon />}
                    onClick={() => handleClickDeleteDinamico(val)}
                  />
                </Stack>
                <Divider sx={{ mt: 1 }} />
              </div>
            ))}

          </Paper>
        </Grid>
        <Grid item xs={3}>
          <Paper sx={{ maxWidth: 400 }}>
            <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} >
              {emails.map((val, index) => (
                <ListItem key={index + "_email"}
                  secondaryAction={
                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteEmail(index)}>
                      <DeleteIcon />
                    </IconButton>
                  }
                >
                  <ListItemText
                    primary={val}
                  // secondary={'Secondary text'}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
      <DialogCuston
        open={openDialog}
        onClose={handleClose}
        dinamico={dinamico}
        onChange={onChangeDialog}
      />
    </Container>
  );
}
